/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_Your_Full_NameInputs */

const en_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your full name`)
};

const es_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu nombre completo`)
};

const fr_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre nom complet`)
};

const de_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib deinen vollständigen Namen ein`)
};

const ja_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`氏名(フルネーム)を入力してください`)
};

const zh_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的全名`)
};

const ar_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل اسمك بالكامل`)
};

const id_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan nama lengkap Anda`)
};

const it_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il tuo nome e cognome`)
};

const ru_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите ваше полное имя`)
};

const pt_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o seu nome completo`)
};

const ko_enter_your_full_name = /** @type {(inputs: Enter_Your_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`성함을 입력해 주세요`)
};

/**
* | output |
* | --- |
* | "Enter your full name" |
*
* @param {Enter_Your_Full_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enter_your_full_name = /** @type {((inputs?: Enter_Your_Full_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_Your_Full_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enter_your_full_name(inputs)
	if (locale === "es") return es_enter_your_full_name(inputs)
	if (locale === "fr") return fr_enter_your_full_name(inputs)
	if (locale === "de") return de_enter_your_full_name(inputs)
	if (locale === "ja") return ja_enter_your_full_name(inputs)
	if (locale === "zh") return zh_enter_your_full_name(inputs)
	if (locale === "ar") return ar_enter_your_full_name(inputs)
	if (locale === "id") return id_enter_your_full_name(inputs)
	if (locale === "it") return it_enter_your_full_name(inputs)
	if (locale === "ru") return ru_enter_your_full_name(inputs)
	if (locale === "pt") return pt_enter_your_full_name(inputs)
	return ko_enter_your_full_name(inputs)
});